import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../store/auth";

interface Props {
  allow?: ("superuser" | "admin" | "employee")[];
}

export function ProtectedRoute({ allow }: Props) {
  const { user, accessToken, mustChangePassword } = useAuthStore();
  const location = useLocation();

  if (!user || !accessToken) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (allow && !allow.includes(user.role)) {
    return <Navigate to={user.role === "superuser" ? "/admins" : "/dashboard"} replace />;
  }
  return <Outlet />;
}
